export const EDITOR_MODAL_TEMPLATES_LIBRARY = 'Library';
export const EDITOR_MODAL_TEMPLATES_PERSONAL = 'Personal';
export const EDITOR_MODAL_TEMPLATES_TEAM = 'Team';
